export default "; datasetStatus\n(fn [dataset]\n\t (query {:select [:status :text] :from [:dataset] :where [:= :name dataset]}))\n";